
import React from 'react';
import Tooltip from '../../../components/Tooltip';

const Step2_Usage = ({ formData, handleChange, nextStep, prevStep }) => {

  const renderRadioCard = (name, value, label, description) => (
    <label className={`block p-4 border rounded-lg cursor-pointer transition ${formData[name] === value ? 'bg-blue-50 border-blue-500 ring-2 ring-blue-500' : 'bg-white border-gray-300 hover:border-gray-400'}`}>
      <input 
        type="radio" 
        name={name} 
        value={value} 
        checked={formData[name] === value} 
        onChange={handleChange} 
        className="sr-only" 
      />
      <span className="font-bold text-gray-800">{label}</span>
      <p className="text-sm text-gray-500 mt-1">{description}</p>
    </label>
  );

  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Étape 2 : Usage et besoins</h2>
      <div className="space-y-6">

        <div>
          <label htmlFor="dailyMileage" className="flex items-center text-sm font-medium text-gray-600 mb-1">
            Kilométrage moyen par jour (km)
            <Tooltip text="Indiquez la distance moyenne que vous parcourez chaque jour. Cela nous aide à estimer vos besoins en recharge." />
          </label>
          <input type="number" id="dailyMileage" name="dailyMileage" value={formData.dailyMileage} onChange={handleChange} placeholder="Ex: 40" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-600 mb-2">Lieu de stationnement principal</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {renderRadioCard('parkingLocation', 'Maison individuelle', 'Maison individuelle', 'Installation sur votre propriété.')}
            {renderRadioCard('parkingLocation', 'Copropriété', 'Copropriété', 'Parking commun ou box privé.')}
            {renderRadioCard('parkingLocation', 'Entreprise', 'Entreprise', 'Pour vos employés ou votre flotte.')}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-600 mb-2">Type d'installation souhaité</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {renderRadioCard('installationType', 'Intérieur garage', 'Intérieur', 'Dans un garage ou un parking couvert.')}
            {renderRadioCard('installationType', 'Extérieur', 'Extérieur', 'Sur un mur extérieur ou sur pied.')}
          </div>
        </div>

        <div>
          <label htmlFor="desiredPower" className="flex items-center text-sm font-medium text-gray-600 mb-1">
            Puissance de recharge souhaitée
            <Tooltip text="7.4kW est standard pour la maison. 11kW et 22kW nécessitent une installation triphasée et offrent une charge plus rapide." />
          </label>
          <select id="desiredPower" name="desiredPower" value={formData.desiredPower} onChange={handleChange} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
            <option>3.7 kW</option>
            <option>7.4 kW</option>
            <option>11 kW</option>
            <option>22 kW</option>
          </select>
        </div>

      </div>

      <div className="mt-8 flex justify-between">
        <button type="button" onClick={prevStep} className="px-8 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-colors">
          Précédent
        </button>
        <button type="button" onClick={nextStep} className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
          Suivant
        </button>
      </div>
    </div>
  );
};

export default Step2_Usage;
